///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2002-2025, Open Design Alliance (the "Alliance").
// All rights reserved.
//
// This software and its documentation and related materials are owned by
// the Alliance. The software may only be incorporated into application
// programs owned by members of the Alliance, subject to a signed
// Membership Agreement and Supplemental Software License Agreement with the
// Alliance. The structure and organization of this software are the valuable
// trade secrets of the Alliance and its suppliers. The software is also
// protected by copyright law and international treaty provisions. Application
// programs incorporating this software must include the following statement
// with their copyright notices:
//
//   This application incorporates Open Design Alliance software pursuant to a
//   license agreement with Open Design Alliance.
//   Open Design Alliance Copyright (C) 2002-2025 by Open Design Alliance.
//   All rights reserved.
//
// By use of this software, its documentation or related materials, you
// acknowledge and accept the above terms.
///////////////////////////////////////////////////////////////////////////////

// ===================== AI-CODE-FILE ======================
// Source: Claude Sonnet 4
// Date: 2025-09-10
// Reviewer: vitaly.ivanov@opendesign.com
// Issue: CLOUD-5835
// Notes: Originally AI-generated, modified manually 2025-09-11
// =========================================================

import { IComponent } from "@inweb/viewer-core";
import type { Viewer } from "../Viewer";
import { Vector3 } from "three";

export class ResetComponent implements IComponent {
  private viewer: Viewer;
  private savedCameraPosition: any = null;

  constructor(viewer: Viewer) {
    this.viewer = viewer;
    this.viewer.addEventListener("databasechunk", this.onDatabaseChunk);
    this.viewer.on("resetview", this.resetCameraPosition);
  }

  dispose() {
    this.viewer.off("resetview", this.resetCameraPosition);
    this.viewer.removeEventListener("databasechunk", this.onDatabaseChunk);
  }

  onDatabaseChunk = () => {
    this.savedCameraPosition = {
      position: this.viewer.camera.position.clone(),
      up: this.viewer.camera.up.clone(),
      direction: this.viewer.camera.getWorldDirection(new Vector3()),
    };
  };

  resetCameraPosition = () => {
    if (this.savedCameraPosition) {
      this.viewer.camera.position.copy(this.savedCameraPosition.position);
      this.viewer.camera.up.copy(this.savedCameraPosition.up);
      this.viewer.camera.lookAt(this.savedCameraPosition.position.clone().add(this.savedCameraPosition.direction));
      this.viewer.camera.updateProjectionMatrix();
    }
  };
}
